import equal from 'fast-deep-equal';
import setSiteMeta from '../base-saving-actions/set-site-meta';

const updateMetaRedirects = (initialRedirects, currentRedirects) => {
  if (equal(initialRedirects, currentRedirects)) return null;

  return setSiteMeta(['redirects'], currentRedirects);
};

export default updateMetaRedirects;
